module.exports = __webpack_public_path__ + "img/invite-patients-button-en.efb6bdde.png";